let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3GBzS"), load("567AN")]).then(() => parcelRequire('f3rHG'));